import { useGetIntegrationsQuery } from "@api/integrations";
import { useMemo } from "react";
import type { PickerTab } from "../types";

export interface PickerTabDef {
  id: PickerTab;
  label: string;
}

/**
 * Available picker tabs, in the order the design lays them out (Figma
 * 816:60179): Storydoc, Custom, then the integrations. Storydoc + Custom are
 * always present; HubSpot and Fathom appear only when their integration is
 * connected (same detection as the legacy variables popover / share dialog).
 */
export const usePickerTabs = (): PickerTabDef[] => {
  const { data } = useGetIntegrationsQuery({});

  return useMemo(() => {
    const integrations = (data ?? []) as Array<{
      vendor?: string;
      active?: boolean;
    }>;
    const hasHubspot = integrations.some(
      (i) => i.vendor === "hubspot" && i.active,
    );
    const hasFathom = integrations.some(
      (i) => i.vendor === "fathom" && i.active,
    );

    const tabs: PickerTabDef[] = [
      { id: "storydoc", label: "Storydoc" },
      { id: "custom", label: "Custom" },
    ];
    if (hasHubspot) tabs.push({ id: "hubspot", label: "HubSpot" });
    if (hasFathom) tabs.push({ id: "fathom", label: "Fathom" });
    return tabs;
  }, [data]);
};
